import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { View } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
// import { Auth } from '@aws-amplify/auth';
import { signOut, updateUserAttributes, fetchAuthSession } from '@aws-amplify/auth';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';

import ProfileForm from '../../components/forms/user/ProfileForm';
import { AppSyncClientAuthenticated } from '../../backends/AppSyncClient';
import GetUser from '../../q/GetUser';
import AddUserImage from '../../q/AddUserImage';
import AORTypes from '../../types';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

class Profile extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Profile';

    this.onApply = this.onApply.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSignOut = this.onSignOut.bind(this);
  }

  async onApply(values) {
    const {
      onUpdateUser,
      user,
      getAnalyticsService,
      history,
    } = this.props;
    let { userData } = this.props;
    const {
      uuid, year, image, langs,
    } = userData;
    const { name } = values;

    userData = { ...userData };
    userData.name = name;
    userData.desc = values.publisher.data.desc;

    return updateUserAttributes({
      userAttributes: {
        preferred_username: name,
        // email: values.email,
        // username: values.username,
      },
    })
      .then(async () => {
        getAnalyticsService().report.event('update', 'user');

        user.attributes.preferred_username = name;
        try {
          // currentAuthenticatedUser({ bypassCache: true });
          fetchAuthSession();
        } catch (_e) {
          // do nothing. something is happening here for Google Users.
        }

        await onUpdateUser({
          uuid,
          name,
          desc: values.publisher.data.desc,
          year,
          image,
          langs,
        })
          .then(() => {
            getAnalyticsService().report.event('updateUser', 'userData');

            this.forceUpdate();
            history.go(-1);
            return null;
          })
          .catch((e) => {
            console.log('error on onSave');
            console.log(e);
            getAnalyticsService().report.error(e);
            return e.message;
          });
      })
      .catch((e) => {
        console.log('error on updateUserAttributes');
        console.log(e);
        getAnalyticsService().report.error(e);
        if (e.code === 'AliasExistsException') {
          return translate('create_app_guide_exists');
        }
        return e.message;
      });

    // TODO(clairbee): implement email change flow
    // Auth.updateUserAttributes(user, {
    //   email: values.email,
    //   username: values.username,
    // });
  }

  onCancel() {
    const { history, getAnalyticsService } = this.props;

    getAnalyticsService().report.event('profile_cancel', 'user');

    history.go(-1);
  }

  onSignOut() {
    const { history, getAnalyticsService } = this.props;

    signOut().then(() => {
      (async () => { await AsyncStorage.clear(); })();
      getAnalyticsService().report.event('sign_out', 'user');

      history.push('/signin');
    }).catch((e) => {
      console.log(e);

      getAnalyticsService().report.error(e);
    });
  }

  render() {
    const {
      user,
      userData,
      onAddUserImage,
      updateUserData,
      getUploader,
      history,
    } = this.props;

    // TODO(clairbee): distinguish authentication and loading the profile info
    // TODO(clairbee): display what are we busy with
    // TODO(clairbee): if authentication failed, redirect to the sign in page
    if (!user || !userData) {
      // This happends before the profile is loaded or right after the users logs out.
      console.log('something is missing');
      console.log(user);
      console.log(userData);
      return (
        <>
        </>
      );
    }

    return (
      <View style={styles.view.headed}>
        <ProfileForm
          user={user}
          userData={userData}
          onAddUserImage={onAddUserImage}
          updateUserData={updateUserData}
          getUploader={getUploader}
          onApply={this.onApply}
          onCancel={this.onCancel}
          onSignOut={this.onSignOut}
          history={history}
        />
      </View>
    );
  }
}

Profile.defaultProps = {
  user: null,
  userData: null,
  updateUserData: () => null,
};

Profile.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  userData: AORTypes.User,
  history: ReactRouterPropTypes.history.isRequired,
  onAddUserImage: PropTypes.func.isRequired,
  onUpdateUser: PropTypes.func.isRequired,
  updateUserData: PropTypes.func,
  getUploader: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
};

export default compose(
  graphql(AddUserImage, {
    name: 'onAddUserImage',
    // name: 'AddEndpointImage',
    props: (props) => ({
      onAddUserImage: ({
        uuid, name, isVertical, type,
      }) => {
        console.log('onAddUserImage');
        console.log(props);

        return props.onAddUserImage({
          variables: {
            uuid,
            name,
            isVertical,
            type,
          },
          // TODO(clairbee): optimisticResponse breaks refetchQueries
          // optimisticResponse: () => ({
          //   updateEndpoint:
          //     endpoint.makeOptimistic().output(),
          // }),
        });
      },
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetUser,
        variables: { uuid: props.user && props.user.attributes.sub },
        client: AppSyncClientAuthenticated(props.user),
      }],
      // fetchPolicy: 'no-cache',
      client: AppSyncClientAuthenticated(props.user),
    }),
  })
)(Profile);
